/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from 'react';
import { FieldAttributes, FieldProps, Field } from 'formik';

import FormikWrapper from '../FormikWrapper';

import * as Styled from './FormikInputTyped.styles';

interface FormikInputProps extends FieldAttributes<any> {
  name: string;
  type?: string;
  label?: string | JSX.Element;
  placeholder?: string;
  helpText?: string | JSX.Element;
  subText?: string;
  size?: 'shortest' | 'short' | 'medium' | 'large' | 'largest' | 'full';
  display?: string;
  hasBottomMargin?: boolean;
  topMargin?: string;
  error?: any;
  disabled?: boolean;
  children?: (props: FieldProps<any>) => React.ReactNode;
  required?: boolean;
  component?: string;
  width?: string;
  maxLength?: number | null;
  zIndex?: number | null;
}

/**
 * Typescript version of FormikInput.
 * TODO: Refactor JS version of FormikInput to this one.
 *
 * @param param0
 * @returns
 */
const FormikInputTyped: FunctionComponent<FormikInputProps> = ({
  name,
  type,
  label,
  placeholder,
  helpText,
  subText,
  display,
  size,
  hasBottomMargin,
  topMargin,
  error,
  disabled,
  children,
  required,
  width,
  maxLength,
  zIndex = null,
  ...fieldProps
}) => {
  const renderCharacterCount = (value: any): JSX.Element => {
    if (maxLength && !!value) {
      return <Styled.CharacterCount>{`${value.length}/${maxLength}`}</Styled.CharacterCount>;
    }

    return <Styled.CharacterCount>{`0/${maxLength}`}</Styled.CharacterCount>;
  };
  return (
    <FormikWrapper
      id={name}
      label={label}
      disabled={disabled}
      showAsterisk={required}
      helpText={helpText}
      display={display}
      size={size}
      hasBottomMargin={hasBottomMargin}
      topMargin={topMargin}
      error={error}
      width={width}
    >
      <Field name={name}>
        {({ field }: FieldProps<any>): JSX.Element => {
          return (
            <Styled.RelativeWrapper zIndex={zIndex}>
              <Styled.StyledFormikField
                id={name}
                {...field}
                type={type}
                disabled={disabled}
                placeholder={placeholder}
                $error={error}
                maxLength={maxLength}
                {...fieldProps}
              >
                {children}
              </Styled.StyledFormikField>
              {maxLength && renderCharacterCount(field.value)}
            </Styled.RelativeWrapper>
          );
        }}
      </Field>

      {subText && <Styled.SubText disabled={disabled}>{subText}</Styled.SubText>}
    </FormikWrapper>
  );
};

export default FormikInputTyped;
